<template>
   <textarea
     class="message-input scroll-px-5"
     :value="text"
     tabindex="1"
     @input="text = $event.target.value"
     @enter="send"
     @keydown="handleKeydown"
     @focus="markAsReadMessage"
     :placeholder="$t('chat.typeYourMessage')"
     rows="1"
   ></textarea>
</template>

<script>
export default {
  name: 'ChatForm',
  data: () => ({
    text: ''
  }),
  methods: {
    send () {
      if (this.text.trim()) {
        this.$emit('sendNewMessage', this.text)
        this.text = ''
      }
    },
    handleKeydown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault()
        this.send()
      }
    },
    markAsReadMessage () {
      this.$emit('markAsReadMessage')
    }
  }
}
</script>

<style lang="scss" scoped>
.message-input {
  width: 100%;
  height: 100%;
  resize: none;
  background-color: #EDF2F7;
  padding: 4px 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
  color: #7A828A;
  outline: none;

  &::placeholder {
    color: #7A828A;
    font-weight: 500;
    font-size: 15px;
 }
}

::-webkit-scrollbar {
  background-color: #EDF2F7;
  width: 8px
}

::-webkit-scrollbar-track {
  background-color: #EDF2F7;
}

::-webkit-scrollbar-track:hover {
  background-color: #EDF2F7;
}

::-webkit-scrollbar-thumb {
  background-color:#babac0;
  border-radius: 8px;
  border: 2px solid #EDF2F7
}
::-webkit-scrollbar-thumb:hover {
  background-color:#babac0;
  border: 2px solid #EDF2F7
}
</style>
